var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_Announcement_form_editTitle")
        : _vm.$t("label_essweb_Announcement_form_viewTitle"),
      backgroundClass: "white",
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-company-announcement"),
      initData: _vm.announcementData,
      checkData: ["message_title", "message_content", "send_org_level_uuid"],
      delBtn: _vm.hasBtn("delete-company-announcement"),
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_admin_Announcement_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
    },
    scopedSlots: _vm._u([
      {
        key: "appendTitle",
        fn: function () {
          return [
            _vm.announcementData
              ? _c(
                  "v-chip",
                  {
                    staticClass: "pl-0 ml-2 pr-2 mr-4",
                    attrs: { small: "", pill: "" },
                  },
                  [
                    _c("svg-icon", {
                      staticClass: "mr-1",
                      attrs: {
                        size: "18",
                        fill:
                          Number(_vm.announcementData.send_status) == 0
                            ? "green"
                            : Number(_vm.announcementData.send_status) == 1
                            ? "orange"
                            : Number(_vm.announcementData.send_status) == 2
                            ? "grey"
                            : "grey",
                        iconClass: "LabeledColour",
                      },
                    }),
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getCommonLangValue(
                              _vm.announcementData.send_status_detail
                            )
                          ) +
                          " "
                      ),
                    ],
                  ],
                  2
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "nav-actions",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center", justify: "start" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            maxlength: "200",
                            label: _vm.$t(
                              "label_essweb_Announcement_form_announcementTitleLabel"
                            ),
                          },
                          model: {
                            value: _vm.announcementData.message_title,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "message_title",
                                $$v
                              )
                            },
                            expression: "announcementData.message_title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("DateTimePicker", {
                          attrs: {
                            isRequire: "",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            type: "datetimerange",
                            value: _vm.dateTerminal,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            defaultStartTime:
                              _vm.announcementData.send_start_utc_datetime,
                            defaultEndTime:
                              _vm.announcementData.send_end_utc_datetime,
                            label: _vm.$t(
                              "label_essweb_Announcement_form_publicTimeLabel"
                            ),
                          },
                          on: {
                            change: function (time, isre) {
                              _vm.dateTerminal = time
                              if (isre) {
                                _vm.announcementData.send_start_utc_datetime =
                                  time ? time.split(" - ")[0] : ""
                                _vm.announcementData.send_end_utc_datetime =
                                  time ? time.split(" - ")[1] : ""
                              }
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_Announcement_form_orgLeaveLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-combobox", {
                          attrs: {
                            items: [],
                            multiple: "",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            "append-icon": "",
                            "item-color": "transparent",
                            "small-chips": "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            dense: "",
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  data.index < _vm.$selectSetting.maxChips
                                    ? _c(
                                        "v-chip",
                                        _vm._b(
                                          {
                                            staticClass: "mx-1 my-1",
                                            attrs: {
                                              pill: "",
                                              "input-value": data.selected,
                                              close: _vm.iSEdited,
                                            },
                                            on: {
                                              click: data.select,
                                              "click:close": function ($event) {
                                                return _vm.removeOrg(data.item)
                                              },
                                            },
                                          },
                                          "v-chip",
                                          data.attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item.org_level_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  data.index === _vm.$selectSetting.maxChips
                                    ? _c(
                                        "span",
                                        { staticClass: "text--primary py-2" },
                                        [
                                          _vm._v(
                                            " ..." +
                                              _vm._s(
                                                _vm.announcementData
                                                  .send_org_level_uuid.length -
                                                  _vm.$selectSetting.maxChips
                                              ) +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_selection_moreItemLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "no-data",
                              fn: function () {
                                return [
                                  _vm.orgData.length == 0
                                    ? _c("noContent")
                                    : _c("v-treeview", {
                                        attrs: {
                                          selectable: "",
                                          "open-all": "",
                                          "open-on-click": "",
                                          search: _vm.search,
                                          filter: _vm.filter,
                                          "selected-color": "primary",
                                          items: _vm.orgData,
                                          "item-key": "uuid",
                                          "return-object": "",
                                          "item-text": "org_level_name",
                                          "item-children": "son_org",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "label",
                                            fn: function (ref) {
                                              var item = ref.item
                                              return [
                                                _c("span", {
                                                  staticClass:
                                                    "text--secondary",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.hightLightKeyword(
                                                        item.org_level_name,
                                                        _vm.search
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.announcementData
                                              .send_org_level_uuid,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.announcementData,
                                              "send_org_level_uuid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "announcementData.send_org_level_uuid",
                                        },
                                      }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.announcementData.send_org_level_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "send_org_level_uuid",
                                $$v
                              )
                            },
                            expression: "announcementData.send_org_level_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_Announcement_form_contentLabel"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            readonly: !_vm.iSEdited,
                            filled: _vm.iSEdited,
                            maxlength: "500",
                            dense: "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            counter: "500",
                            "single-line": "",
                          },
                          model: {
                            value: _vm.announcementData.message_content,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "message_content",
                                $$v
                              )
                            },
                            expression: "announcementData.message_content",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-checkbox", {
                          attrs: {
                            disabled: !_vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_Announcement_form_confirmReadLabel"
                            ),
                            required: "",
                          },
                          model: {
                            value: _vm.announcementData.is_confirm_read,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "is_confirm_read",
                                $$v
                              )
                            },
                            expression: "announcementData.is_confirm_read",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }